// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Restaumatic_Menu_Menu from "../Restaumatic.Menu.Menu/index.js";
import * as Restaumatic_Menu_Promotions from "../Restaumatic.Menu.Promotions/index.js";
import * as Restaumatic_Menu_Query from "../Restaumatic.Menu.Query/index.js";
import * as Restaumatic_Menu_V2_Types_FulfillmentMethod from "../Restaumatic.Menu.V2.Types.FulfillmentMethod/index.js";
import * as Restaumatic_Menu_V2_Types_PaymentMethod from "../Restaumatic.Menu.V2.Types.PaymentMethod/index.js";
import * as Restaumatic_Promotions_Types from "../Restaumatic.Promotions.Types/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Types_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var FreeProductInputOptions = /* #__PURE__ */ (function () {
    function FreeProductInputOptions(value0) {
        this.value0 = value0;
    };
    FreeProductInputOptions.create = function (value0) {
        return new FreeProductInputOptions(value0);
    };
    return FreeProductInputOptions;
})();
var CouponCodeInputOptions = /* #__PURE__ */ (function () {
    function CouponCodeInputOptions() {

    };
    CouponCodeInputOptions.value = new CouponCodeInputOptions();
    return CouponCodeInputOptions;
})();
var NoInputOptions = /* #__PURE__ */ (function () {
    function NoInputOptions() {

    };
    NoInputOptions.value = new NoInputOptions();
    return NoInputOptions;
})();
var newPromotionDetails = function (v) {
    return {
        id: v.promotionId,
        name: v.name,
        description: v.description,
        inputOptions: (function () {
            if (v.prize instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.Freeby) {
                return new FreeProductInputOptions({
                    choices: Data_Functor.map(Data_Functor.functorArray)((function () {
                        var $30 = Data_Newtype.unwrap();
                        return function ($31) {
                            return (function (v2) {
                                return v2.productName;
                            })($30($31));
                        };
                    })())(v.prize.value0)
                });
            };
            if (v.prize instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CouponValue) {
                return CouponCodeInputOptions.value;
            };
            return NoInputOptions.value;
        })()
    };
};
var promotionDetails = function (id) {
    return Data_Functor.map(Restaumatic_Menu_Query.functorMenuQuery)(newPromotionDetails)(Restaumatic_Menu_Query.findPromotion(id));
};
var matchPaymentMethod = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Nothing) {
            return true;
        };
        if (v instanceof Data_Maybe.Just) {
            return Data_Maybe.isNothing(Data_Record.getField(Restaumatic_Promotions_Types.hasFieldPromotion(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "groupId";
                }
            })()))(Type_Proxy["Proxy"].value)(v1)) || Data_Eq.eq(Restaumatic_Menu_V2_Types_PaymentMethod.eqPaymentMethod)(v.value0)(Restaumatic_Menu_V2_Types_PaymentMethod.PaymentMethodOnline.value);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.PromotionData (line 50, column 1 - line 50, column 66): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var matchFulfillmentMethod = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Nothing) {
            return true;
        };
        if (v instanceof Data_Maybe.Just) {
            var v2 = Data_Record.getField(Restaumatic_Promotions_Types.hasFieldPromotion(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "availableAt";
                }
            })()))(Type_Proxy["Proxy"].value)(v1);
            if (v2 instanceof Restaumatic_Promotions_Types.DeliveryOnly) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_FulfillmentMethod.eqFulfillmentMethod)(v.value0)(Restaumatic_Menu_V2_Types_FulfillmentMethod.Delivery.value);
            };
            if (v2 instanceof Restaumatic_Promotions_Types.TakeawayOnly) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_FulfillmentMethod.eqFulfillmentMethod)(v.value0)(Restaumatic_Menu_V2_Types_FulfillmentMethod.Takeaway.value);
            };
            if (v2 instanceof Restaumatic_Promotions_Types.RestaurantOnly) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_FulfillmentMethod.eqFulfillmentMethod)(v.value0)(Restaumatic_Menu_V2_Types_FulfillmentMethod.DineIn.value);
            };
            if (v2 instanceof Restaumatic_Promotions_Types.DeliveryAndTakeaway) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_FulfillmentMethod.eqFulfillmentMethod)(v.value0)(Restaumatic_Menu_V2_Types_FulfillmentMethod.Delivery.value) || Data_Eq.eq(Restaumatic_Menu_V2_Types_FulfillmentMethod.eqFulfillmentMethod)(v.value0)(Restaumatic_Menu_V2_Types_FulfillmentMethod.Takeaway.value);
            };
            if (v2 instanceof Restaumatic_Promotions_Types.RestaurantAndTakeaway) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_FulfillmentMethod.eqFulfillmentMethod)(v.value0)(Restaumatic_Menu_V2_Types_FulfillmentMethod.DineIn.value) || Data_Eq.eq(Restaumatic_Menu_V2_Types_FulfillmentMethod.eqFulfillmentMethod)(v.value0)(Restaumatic_Menu_V2_Types_FulfillmentMethod.Takeaway.value);
            };
            if (v2 instanceof Restaumatic_Promotions_Types.Everywhere) {
                return true;
            };
            throw new Error("Failed pattern match at Restaumatic.Cart.PromotionData (line 56, column 50 - line 62, column 21): " + [ v2.constructor.name ]);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.PromotionData (line 54, column 1 - line 54, column 74): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var isLoyaltyPromotion = function (v) {
    return Data_Eq.eq(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.eqPromotionConditions)(v.conditions)(new Restaumatic_PromotionsEngine_Promotions_Types_Promotion.CartPromotion(Restaumatic_PromotionsEngine_Promotions_Types_Promotion.Loyalty.value));
};
var genericPromotionInputOptions = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new FreeProductInputOptions(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return CouponCodeInputOptions.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return NoInputOptions.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.PromotionData (line 35, column 1 - line 35, column 80): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof FreeProductInputOptions) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof CouponCodeInputOptions) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof NoInputOptions) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.PromotionData (line 35, column 1 - line 35, column 80): " + [ x.constructor.name ]);
    }
};
var eqPromotionInputOptions = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPromotionInputOptions)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "choices";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqString))))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))
};
var enginePromotions = function (menu) {
    return function (mFulfillmentMethod) {
        return function (mPaymentMethod) {
            return Data_Functor.map(Data_Functor.functorArray)(Restaumatic_Menu_Promotions.toEnginePromotion)(Data_Array.filter(matchFulfillmentMethod(mFulfillmentMethod))(Data_Array.filter(matchPaymentMethod(mPaymentMethod))(Data_Array.filter((function () {
                var $32 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
                return function ($33) {
                    return $32(isLoyaltyPromotion($33));
                };
            })())(Data_Array.fromFoldable(Data_Map_Internal.foldableMap)(Restaumatic_Menu_Menu.promotions(menu))))));
        };
    };
};
export {
    FreeProductInputOptions,
    CouponCodeInputOptions,
    NoInputOptions,
    enginePromotions,
    promotionDetails,
    genericPromotionInputOptions,
    eqPromotionInputOptions
};
//# sourceMappingURL=index.js.map
